import { Button, DatePicker, Form, Input, InputNumber, Radio, Select } from 'antd';

// import './index.css';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  FeeFilterPayload,
  getFeesPaymentList,
  getSelectList,
  SelectList,
  SelectPayload,
  SelectResponse,
} from 'api/dashboard';
import { FileExcelFilled } from '@ant-design/icons';
import FeeFilterList from '../FeesList/FeeFilterList';
import xlsx from 'json-as-xlsx';
import moment from 'moment';
import { handleOnlyNumber } from 'features/nach/utils/handleOnlyNumber';

const dateFormat = 'DD/MM/YYYY';
function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('YYYY/DD/MM HH:mm:ss');
    return dateMoment;
  }
}
type Props = {
  isLoading: boolean;
  onSubmit: (values: FeeFilterPayload) => Promise<void>;
};

const filterPayload: FeeFilterPayload = {};
const initPartners: SelectList[] = [];
const initSelectResp: SelectResponse = {
  data: [],
};
const Filter = ({ onSubmit }: Props) => {
  const { Option } = Select;

  const [form] = Form.useForm<FeeFilterPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const [statusList, setStatus] = useState(initPartners);
  const [statusId, setStatusId] = useState(0);
  const [_sourceId, setSourceId] = useState(0);
  const [sources, setSource] = useState(initSelectResp);
  const [feeType, setFeeType] = useState('');
  const [onlyDigitError, setOnlyDigitError] = useState(false);
  // const [search, setSearch] = useState(true);
  const isAdmin = sessionStorage.getItem('isAdmin');
  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'StatusSource',
    };
    getSelectList(statusPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setStatus(res.data);
      // console.log(res.data);
    });

    // setAdmin(adminRole);
    if (isAdmin == 'true') {
      const sourcePayload: SelectPayload = {
        SKey: 'Source',
      };
      // setIsLoading(false);
      getSelectList(sourcePayload).then((res) => {
        // setPagedList(res);
        //   setIsLoading(true);
        // console.log(res);
        setSource(res);
      });
    }
  }, []);

  // console.log(filter);
  const handleStatusId = (e: any) => {
    form.setFieldValue('statusId', e);
    form.validateFields(['statusId']);
    setStatusId(Number(e));
  };

  const handleSourceId = (e: any) => {
    form.setFieldValue('sourceId', e);
    form.validateFields(['sourceId']);
    setSourceId(Number(e));
  };

  const handleSubmit = useCallback(
    async (values: FeeFilterPayload) => {
      // debugger;
      let updatedValues = { ...values };
      //updatedValues.Username = sessionStorage.getItem('user')?.toString();
      if (isAdmin != 'true') {
        updatedValues.sourceApplicationName = sessionStorage.getItem('source')?.toString();
      }
      // updatedValues.feeType = feeType;
      // updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      setFilter(updatedValues);

      console.log(updatedValues);
      // form.resetFields();
    },
    [onSubmit, form]
  );

  // function handleDownload(_e: any) {
  //   const filterValues: FeeFilterPayload = form.getFieldsValue();
  //   filterValues.isExtract = true;

  //   if (isAdmin != 'true') {
  //     filterValues.sourceApplicationName = sessionStorage.getItem('source')?.toString();
  //   }
  //   debugger;
  //   (filterValues).then((_x) => {
  //     const dashboardData = _x.data.data;
  //     debugger;
  //     if (dashboardData.length <= 0) {
  //       message.info('No Result Extrated');
  //     }
  //     const csvConfig = mkConfig({
  //       useKeysAsHeaders: true,
  //       filename: 'Fees Dashboard - Report',
  //     });
  //     const csv = generateCsv(csvConfig)(dashboardData);
  //     download(csvConfig)(csv);
  //   });
  // }

  // function handleDate(_e: any) {
  //   filter.PaymentDateFrom = moment(_e, 'DD/MM/YYYY').toString();
  // }
  // function handleDownload(_e: any) {
  //   const filterValues: FeeFilterPayload = form.getFieldsValue();
  //   filterValues.isExtract = true;
  //   filterValues.pageNo = 1;
  //   filterValues.pageSize = 10;

  //   if (isAdmin != 'true') {
  //     filterValues.sourceApplicationName = sessionStorage.getItem('source')?.toString();
  //   }

  //   getFeesPaymentList(filterValues).then((_x) => {
  //     let settings = {
  //       fileName: 'Fees Dashboard - Report', // Name of the resulting spreadsheet
  //       extraLength: 3, // A bigger number means that columns will be wider
  //       writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
  //       writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
  //       //RTL: true, // Display the columns from right-to-left (the default value is false)
  //     };

  //     let data = [
  //       {
  //         sheet: 'Sheet 1',
  //         columns: [
  //           { label: 'ROWNUM', value: 'ROWNUM' },
  //           { label: 'Fee Type', value: 'FeeType' },
  //           { label: 'Fee Code', value: 'FeeCode' },
  //           { label: 'Fee Amount', value: 'FeeAmount' },
  //           { label: 'Fee Description', value: 'FeeDescription' },
  //           { label: 'Amount', value: 'AMOUNT' },
  //           { label: 'LANumber', value: 'LANUMBER' },
  //           { label: 'RequestPurpose', value: 'REQUESTPURPOSE' },
  //           { label: 'SourceApplicationName', value: 'SOURCEAPPLICATIONNAME' },
  //           { label: 'PaymentRequestID', value: 'PAYMENTREQUESTID' },
  //           { label: 'LoanType', value: 'LOANTYPE' },
  //           { label: 'RequestStatus', value: 'RequestStatus' },
  //           { label: 'new_status', value: 'NEW_STATUS' },
  //           { label: 'Currency', value: 'CURRENCY' },
  //           { label: 'SessionID', value: 'SESSIONID' },
  //           { label: 'PaymentPurpose', value: 'PAYMENTPURPOSE' },
  //           { label: 'MerchantID', value: 'MERCHANTID' },
  //           { label: 'PaymentRequestDateTime', value: 'PAYMENTREQUESTDATETIME' },
  //           { label: 'Mode', value: 'MODE' },
  //           { label: 'GatewayName', value: 'GATEWAYNAME' },
  //           { label: 'RefTransaction', value: 'REFTRANSACTION' },
  //           { label: 'paymentRef', value: 'PAYMENTREF' },
  //           { label: 'bankCode', value: 'BANKCODE' },
  //           { label: 'valueDate', value: 'valueDate' },
  //           { label: 'favourName', value: 'FAVOURNAME' },
  //           { label: 'remarks', value: 'REMARKS' },
  //           { label: 'razorpay_order_id', value: 'OrderId' },
  //           { label: 'razorpay_payment_id', value: 'razorpay_payment_id' },
  //           { label: 'FundingAccount', value: 'FUNDINGACCOUNT' },
  //           { label: 'PennantReceiptNo', value: 'PENNANTRECEIPTNO' },
  //           { label: 'PennantReceiptDate', value: 'PENNANTRECEIPTDATE' },
  //           { label: 'PennantErrorDesc', value: 'PENNANTERRORDESC' },
  //           { label: 'auth_code', value: 'AUTH_CODE' },
  //           { label: 'PaymentRequestError', value: 'PAYMENTREQUESTERROR' },
  //           { label: 'WebhookError', value: 'WEBHOOKERROR' },
  //           { label: 'verificationReason', value: 'VERIFICATIONREASON' },
  //           { label: 'AgentRejectRemarks', value: 'AGENTREJECTREMARKS' },
  //           { label: 'account_id', value: 'ACCOUNT_ID' },
  //           { label: 'ByAgent', value: 'BYAGENT' },
  //         ],
  //         content: _x.data.data,
  //       },
  //     ];
  //     xlsx(data, settings);
  //   });
  // }

  function handleDownload(_e: any) {
    filter.isExtract = true;
    filter.pageNo = 1;
    filter.pageSize = 10;
    console.log('download filter ', filter);

    // api is not working for it

    // filter.username = sessionStorage.getItem('user')?.toString();

    if (isAdmin != 'true') {
      filter.sourceApplicationName = sessionStorage.getItem('source')?.toString();
    }
    getFeesPaymentList(filter).then((_x) => {
      // console.log('nach dashboard ', _x);
      let settings = {
        fileName: 'Fees Dashboard', // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };
      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index) => ({
        ...item,
        // AccountNo: maskAllDigitsExceptLastFour(item.accountNo),
        // requestDate: getFullDate(item.requestDate),
        // mandateStartDate: getFullDate(item.mandateStartDate),
        // mandateEndDate: getFullDate(item.mandateEndDate),
        // aproveMandateCreatedOn: getFullDate(item.aproveMandateCreatedOn),
        PENNANTRECEIPTDATE: getFullDate(item.PENNANTRECEIPTDATE),
        PAYMENTREQUESTDATETIME: getFullDate(item.PAYMENTREQUESTDATETIME),
        VALUEDATE: getFullDate(item.VALUEDATE),

        ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'Fee Type', value: 'FeeType' },
            { label: 'Fee Code', value: 'FeeCode' },
            { label: 'Fee Amount', value: 'FeeAmount' },
            { label: 'Fee Description', value: 'FeeDescription' },
            { label: 'Amount', value: 'AMOUNT' },
            { label: 'LANumber', value: 'LANUMBER' },
            { label: 'RequestPurpose', value: 'REQUESTPURPOSE' },
            { label: 'SourceApplicationName', value: 'SOURCEAPPLICATIONNAME' },
            { label: 'PaymentRequestID', value: 'PAYMENTREQUESTID' },
            { label: 'LoanType', value: 'LOANTYPE' },
            { label: 'RequestStatus', value: 'RequestStatus' },
            { label: 'new_status', value: 'NEW_STATUS' },
            { label: 'Currency', value: 'CURRENCY' },
            { label: 'SessionID', value: 'SESSIONID' },
            { label: 'PaymentPurpose', value: 'PAYMENTPURPOSE' },
            { label: 'MerchantID', value: 'MERCHANTID' },
            { label: 'PaymentRequestDateTime', value: 'PAYMENTREQUESTDATETIME' },
            { label: 'Mode', value: 'MODE' },
            { label: 'GatewayName', value: 'GATEWAYNAME' },
            { label: 'RefTransaction', value: 'REFTRANSACTION' },
            { label: 'paymentRef', value: 'PAYMENTREF' },
            { label: 'bankCode', value: 'BANKCODE' },
            { label: 'valueDate', value: 'VALUEDATE' },
            { label: 'favourName', value: 'FAVOURNAME' },
            { label: 'remarks', value: 'REMARKS' },
            { label: 'razorpay_order_id', value: 'RAZORPAY_ORDER_ID' },
            { label: 'razorpay_payment_id', value: 'RAZORPAY_PAYMENT_ID' },
            { label: 'FundingAccount', value: 'FUNDINGACCOUNT' },
            { label: 'PennantReceiptNo', value: 'PENNANTRECEIPTNO' },
            { label: 'PennantReceiptDate', value: 'PENNANTRECEIPTDATE' },
            { label: 'PennantErrorDesc', value: 'PENNANTERRORDESC' },
            { label: 'auth_code', value: 'AUTH_CODE' },
            { label: 'PaymentRequestError', value: 'PAYMENTREQUESTERROR' },
            { label: 'WebhookError', value: 'WEBHOOKERROR' },
            { label: 'verificationReason', value: 'VERIFICATIONREASON' },
            { label: 'AgentRejectRemarks', value: 'AGENTREJECTREMARKS' },
            { label: 'account_id', value: 'ACCOUNT_ID' },
            { label: 'ByAgent', value: 'BYAGENT' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
    // setSearch(false);
    setFeeType('');
  }
  const memoizedFilter = useMemo(() => filter, [filter]);
  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Fees Dashboard</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<FeeFilterPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    ['SourceApplicationName']:
                      isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Loan Number :'} name="lANumber" className="fieldTitle">
                          <Input placeholder={'Loan Number'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Order ID :'} name="orderId" className="fieldTitle">
                          <Input placeholder={'Order ID'} />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Status :'} name="requestStatus" className="fieldTitle">
                          <Select
                            placeholder="Select"
                            size="large"
                            value={statusId.toString()}
                            onSelect={handleStatusId}
                          >
                            {statusList.map((status) => (
                              <>
                                <Option value={status.SValue}>{status.SValue}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Purpose :'}
                          name="paymentPurpose"
                          className="fieldTitle"
                        >
                          <Select placeholder="Select" defaultValue="Fees" size="large">
                            <Option value="Fees">Fees</Option>
                            {/* <Option value="Foreclosure">Foreclosure</Option>
                            <Option value="Overdue">Overdue</Option>
                            <Option value="OverdueWithoutCharges">Overdue Without Charges</Option>
                            <Option value="PartPayment">PartPayment</Option>
                            <Option value="ADVANCEEMI">Advance EMI</Option>
                            <Option value="OtherCharges">Other Charges</Option> */}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Request Purpose:'}
                          name="requestPurpose"
                          className="fieldTitle"
                        >
                          <Select placeholder="Select" size="large">
                            <Option value="Payment">Payment</Option>
                            <Option value="Receipt">Receipt</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Payment ID:'} name="paymentId" className="fieldTitle">
                          <Input placeholder={'Payment ID'} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Date From:'}
                          name="fromDate"
                          className="fieldTitle"
                        >
                          <DatePicker format={dateFormat} />
                          {/* <DatePicker format={'DD/MM/YYYY'} onSelect={handleDate} /> */}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'To :'} name="toDate" className="fieldTitle">
                          <DatePicker format={dateFormat} />
                          {/* <DatePicker format={'DD-MM-YYYY'} onSelect={handleDate} /> */}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        {isAdmin == 'true' ? (
                          <Form.Item
                            label={'Source Application Name :'}
                            name="sourceApplicationName"
                            className="fieldTitle"
                          >
                            <Select
                              placeholder="Select"
                              size="large"
                              value={statusId.toString()}
                              onSelect={handleSourceId}
                            >
                              {/* <Option value="0">Select</Option> */}
                              {sources.data.map((role) => (
                                <Option value={role.SText}>{role.SText}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        ) : (
                          <Form.Item
                            label={'Source Application Name :'}
                            name="sourceApplicationName"
                            className="fieldTitle"
                          >
                            <Input
                              disabled={true}
                              style={{
                                border: '1px solid #dcdcdc',
                                borderRadius: '4px',
                                fontWeight: '600',
                                background: '#fafbfa',
                                opacity: 0.5,
                              }}
                            />
                          </Form.Item>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Merchant ID :'} name="merchantId" className="fieldTitle">
                          <Input placeholder={'Merchant ID'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Reference No :'}
                          name="paymentRefNo"
                          className="fieldTitle"
                        >
                          <Input placeholder={'Payment Reference No'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Request ID :'}
                          name="paymentRequestId"
                          className="fieldTitle"
                          validateStatus={onlyDigitError ? 'error' : ''}
                          help={onlyDigitError ? 'Only numbers are allowed' : ''}
                        >
                          <InputNumber
                            value={form.getFieldValue('PaymentRequestId')}
                            onBeforeInput={(e) => handleOnlyNumber(e, setOnlyDigitError)}
                            placeholder={'Payment Request ID:'}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xs-12 col-sm-4 col-md-4">
                        <div className="input-box">
                          {' '}
                          <Form.Item
                            label={'Fee Type :'}
                            name="feeType"
                            style={{ cursor: 'pointer' }}
                            className="fieldTitle"
                          >
                            <Radio.Group
                              name="FeeType"
                              value={feeType}
                              className=""
                              onChange={(e) => setFeeType(e.target.value)}
                              data-toggle="buttons"
                              style={{ paddingBottom: '10px', width: '100%' }}
                            >
                              <label
                                role="button"
                                className="btn btn-primary"
                                style={{
                                  marginRight: '10px',
                                  fontWeight: '400',
                                  fontSize: '14px',
                                  fontFamily: 'sans-serif,regular',
                                  backgroundColor: feeType == 'Upfront' ? '#0062cc' : '#007bff',
                                }}
                              >
                                <Radio
                                  className="rblFeeType"
                                  id="feeType"
                                  name="feeType"
                                  type="radio"
                                  value="Upfront"
                                />
                                Upfront
                              </label>
                              <label
                                role="button"
                                className="btn btn-primary"
                                style={{
                                  marginRight: '10px',
                                  fontWeight: '400',
                                  fontSize: '14px',
                                  fontFamily: 'sans-serif,regular',
                                  backgroundColor:
                                    feeType == 'Post Disbursement' ? '#0062cc' : '#007bff',
                                }}
                              >
                                <Radio
                                  className="rblFeeType"
                                  id="feeType"
                                  name="feeType"
                                  type="radio"
                                  value="Post Disbursement"
                                />
                                Post Disbursement
                              </label>
                            </Radio.Group>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-4 col-md-4">
                        <div className="input-box">
                          <Form.Item
                            label={'Gateway Name :'}
                            name="gatewayName"
                            className="fieldTitle"
                          >
                            <Select placeholder="Select" size="large">
                              <Option value="Phonepe">Phonepe</Option>
                              <Option value="RazorPay">RazorPay</Option>
                              <Option value="NA">NA</Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>

                      <div className="col-xs-12 col-sm-4 col-md-4">
                        <div style={{ marginTop: '20px' }}>
                          <Button
                            type="link"
                            icon={<FileExcelFilled />}
                            style={{
                              float: 'right',
                              fontSize: '30px',
                              color: 'green',
                              // marginTop: '50px',
                              marginLeft: '10px',
                            }}
                            onClick={handleDownload}
                          ></Button>
                          <Button
                            type="primary"
                            htmlType="submit"
                            style={{
                              float: 'right',
                              //  marginTop: '50px',
                              marginLeft: '10px',
                            }}
                            onClick={handleReset}
                          >
                            {'CLEAR'}
                          </Button>

                          <Button
                            type="primary"
                            htmlType="submit"
                            style={{
                              float: 'right',
                              // marginTop: '50px'
                            }}
                            onClick={() => {
                              // setSearch(true);
                            }}
                          >
                            {'SEARCH'}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
              <FeeFilterList
                filter={memoizedFilter}
                handleReset={handleReset}
                onSubmit={handleSubmit}
                setOnlyDigitError={setOnlyDigitError}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
